import { NgModule } from '@angular/core'
import { AbsoluteTooltipComponent } from './absolute-tooltip.component'

@NgModule({
    declarations: [AbsoluteTooltipComponent],
    exports: [AbsoluteTooltipComponent],
})
export class AbsoluteTooltipModule {}